import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import DropDown from "../filters/dropdown";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const SelectSize = ({
  sizeList,
  selectTabInYourRug,
  selectedSizeRug,
  setSelectedSizeRug,
  texts,
}) => {
  const history = useHistory();
  let currentUrlParams = new URLSearchParams(window.location.search);
  const [showSize, setshowSize] = useState(false);
  return (
    <div style={{ marginTop: 50, marginBottom: 50 }}>
      <span style={{ color: "#5e6777", textAlign: "center" }}>
        {texts.selection_size_description}
      </span>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          marginTop: 10,
          rowGap: 10,
          columnGap: 10,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            maxWidth: 363,
            width: "100%",
            marginTop: 30,
            position: "relative",
          }}
        >
          <div
            style={{
              backgroundColor: "#fafafa",
              height: 40,
              marginTop: 8,
              borderRadius: 5,
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
              padding: 16,
              fontSize: 12,
              color: "#5e6777",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
            }}
            onClick={() => setshowSize(true)}
          >
            {selectedSizeRug?.name || sizeList[0]?.name}
            <KeyboardArrowDownRoundedIcon
              style={{
                margin: 0,
                transform: showSize ? "rotate(180deg)" : "rotate(0deg)",
                transition: "0.5s all",
              }}
            />
          </div>
          {showSize ? (
            <div
              className="mt-2"
              style={{
                backgroundColor: "#fafafa",
                borderRadius: 8,
                maxHeight: 200,
                overflowY: "scroll",
                position: "absolute",
                top: 65,
                width: "100%",
                zIndex: 1,
              }}
            >
              {sizeList?.map((size) => (
                <div
                  className="p-2 text-right"
                  style={{ cursor: "pointer", fontSize: 12 }}
                  onClick={() => {
                    setSelectedSizeRug(size);
                    selectTabInYourRug("select_pic");
                    setshowSize(false);
                  }}
                >
                  {size.name}
                </div>
              ))}
            </div>
          ) : null}
        </div>

        {/* <DropDown
          name="جنس"
          list={sizeList}
          engName="yarns"
          selected={selectedSizeRug}
          changeHandler={() => {
            setSelectedSizeRug(size);
            selectTabInYourRug("select_pic");
          }}
        /> */}
        {/* {sizeList?.map((size) => {
          return (
            <button
              className="select-size-btn"
              onClick={() => {
                // currentUrlParams.set("tab", "select_pic");
                // history.push(
                //   window.location.pathname + "?" + currentUrlParams.toString()
                // );
                setSelectedSizeRug(size);
                selectTabInYourRug("select_pic");
              }}
            >
              <div
                style={{
                  borderRadius: 5,
                  border:
                    selectedSizeRug?.id === size.id
                      ? "solid 1px #de2a35"
                      : "solid 1px #dfdede",
                  height: size.height / 3.5,
                  width: size.width / 3.5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: selectedSizeRug === size.id ? "#de2a35" : "#bbc2ce",
                }}
              >
                <span>
                  {size.width} * {size.height}
                </span>
              </div>
              <span style={{ marginTop: 30, color: "#bbc2ce" }}>
                {size.name}
              </span>
            </button>
          );
        })} */}
      </div>
    </div>
  );
};

export default SelectSize;
